import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined';
import { Box } from '@mui/material';
import type { FileType } from './file-type';
import filePdf from '@/assets/images/svg/file-type-pdf.svg';
import fileJpg from '@/assets/images/svg/file-type-jpg.svg';
import filePng from '@/assets/images/svg/file-type-png.svg';

const FILE_TYPE_ICONS: Record<FileType, string> = {
  pdf: filePdf,
  jpg: fileJpg,
  png: filePng,
};

interface FileTypeIconProps {
  type: FileType | null;
  size?: number;
}

export const FileTypeIcon = ({ type, size = 40 }: FileTypeIconProps) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    width={size}
    height={size}
    flexShrink={0}
  >
    {type ? (
      <Box
        component="img"
        src={FILE_TYPE_ICONS[type]}
        alt=""
        aria-hidden
        data-testid={`file-type-icon-${type}`}
        height={size}
      />
    ) : (
      <InsertDriveFileOutlined sx={{ fontSize: size, color: 'neutral.300' }} />
    )}
  </Box>
);
